import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ProductContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: ${({ theme }) => theme.colors.default};
  border-radius: ${({ theme }) => theme.tw.radius.lg};
  padding: ${spacing('lg')} ${spacing('lg')};
  align-items: center;
  @media ${media.minWidth.sm} {
    padding: ${spacing('xl')} ${spacing('xxl')};
  }
  margin-bottom: ${spacing('lg')};
`;

export const $ProductCardImageContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border: 1px solid ${({ theme }) => theme.colors.disabled};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing('lg')};
  margin-left: '${spacing(10)}';
  padding: ${spacing('xxs')};
  img {
    width: -webkit-fill-available;
    max-width: 70px;
  }
  @media ${media.minWidth.sm} {
    width: 70px;
    height: 70px;
  }
`;

export const $ProductInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: ${fontWeight('normal')};
  & > span:first-child {
    font-weight: ${fontWeight('bold')};
  }
`;
